import Vue from 'vue'

export default {
    UPDATE_PLANS (state, value) {
        Vue.set(state, 'plans', value);
    },
    SET_PLANS (state, value) {
        this.commit('UPDATE_PLANS', value);
    },
    SET_SELECTED_PLAN (state,  value ) {
      Vue.set(state, 'selectedPlan', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/plans/mutations.js